import { connect } from 'react-redux'
import {
  GET_PROGRAMS_LIST,
  GET_REFERRALOUTCOME_LIST,
  GET_BOPINSTITUTIONS_LIST,
  GET_DRUGAFTERCAREPROGRAMS_LIST,
  GET_GANGAFFILIATIONS_LIST,
  GET_REFERRALSOURCE_LIST,
                                                                // GET_BHTsINSURANCEPROVIDERS_LIST
} from '../actions/action-constants'
import { getDropDownsList } from '../actions/actions-drop-downs'
import { getArchivedClient } from '../actions/actions-archived-clients'
import ClientViewRoot from '../components/edit-view-client/client-container-root-view'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    clientEntry: state.archivedclientsR.dataEntry,
    initialValues: state.archivedclientsR.dataEntry,
    programsList: state.programsR,
    referralOutcomesList: state.referraloutcomesR,
                                                                  // bhtsinsuranceprovidersList: state.bhtsinsuranceprovidersR,
    // bopinstitutionsList: state.bopinstitutionsR,
    // gangaffiliationsList: state.gangaffiliationsR,
    // referralsourcesList: state.referralsourcesR,
    bopinstitutionsList: state.bopinstitutionsR.bopinstitutions,
    gangaffiliationsList: state.gangaffiliationsR.gangaffiliations,
    referralsourcesList: state.referralsourcesR.referralsources,
    errorInvalidEntry: state.archivedclientsR.errorInvalidEntry,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getArchivedClient: id => {
      dispatch(getArchivedClient(id))
    },
    getPrograms: params => {
      dispatch(getDropDownsList(params, GET_PROGRAMS_LIST))
    },
    getReferralOutcomes: params => {
      dispatch(getDropDownsList(params, GET_REFERRALOUTCOME_LIST))
    },
                                                              // getBHTsInsuranceProviders: params => {
                                                              //   dispatch(getDropDownsList(params, GET_BHTsINSURANCEPROVIDERS_LIST))
                                                              // },
    getBOPInstitutions: params => {
      dispatch(getDropDownsList(params, GET_BOPINSTITUTIONS_LIST))
    },
    getDrugAftercarePrograms: params => {
      dispatch(getDropDownsList(params, GET_DRUGAFTERCAREPROGRAMS_LIST))
    },
    getGangAffiliations: params => {
      dispatch(getDropDownsList(params, GET_GANGAFFILIATIONS_LIST))
    },
    getReferralSources: params => {
      dispatch(getDropDownsList(params, GET_REFERRALSOURCE_LIST))
    }
  }
}
const ArchivedClientListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientViewRoot)
export default ArchivedClientListContainer
